export enum ProductTileType {
  // Product tile that only has product information
  PRODUCT_ONLY_TILE = "PRODUCT_ONLY_TILE_LOGGED_IN",
  // Product tile that is used on the search page
  //  this is a special tile as it has a lot of xp and temporary tracking wrappers
  //  going on with it
  SEARCH_PAGE_PRODUCT_TILE = "SEARCH_PAGE_PRODUCT_TILE",
}
